import React from 'react';

import LottieView from 'lottie-react-native';
import { Modal, StyleSheet, View, useWindowDimensions } from 'react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';
import { primitive, spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

const burgerBounceLoaderFallback = require('../../assets/splash-screen.json');

interface OrderProcessingLoadingProps {
  testID?: string;
  visible?: boolean;
}

const BurgerBounceLoaderAnimation = () => {
  const { width: screenWidth } = useWindowDimensions();
  const uri = useStaticLottieUri(StaticImages.BurgerBounceLoader);
  const { source, error } = useLottieSource({
    source: uri ? { uri } : burgerBounceLoaderFallback,
    surface: 'order_processing',
  });
  const animationWidth = screenWidth * 0.68;
  const animationHeight = animationWidth * 0.55;
  const renderSource = error ? burgerBounceLoaderFallback : source;

  if (!renderSource) {
    return null;
  }

  return (
    <LottieView
      autoPlay
      hardwareAccelerationAndroid
      loop
      resizeMode="contain"
      source={renderSource}
      style={{ width: animationWidth, height: animationHeight }}
      testID="burger-bounce-loader-animation"
      {...(isWeb ? { webStyle: { width: animationWidth, height: animationHeight } } : {})}
    />
  );
};

export const OrderProcessingLoading = ({
  testID = 'order-processing-loading',
  visible = true,
}: OrderProcessingLoadingProps) => {
  if (!visible) {
    return null;
  }

  return (
    <Modal visible transparent animationType="fade" testID={testID}>
      <View style={styles.container}>
        <View style={styles.content}>
          <BurgerBounceLoaderAnimation />
          <View style={styles.textGroup}>
            <Typography bold color={primitive.$bbqBrown} textAlign="center" variant="headerThree">
              {t('processingSubmittedOrderTitle' as TranslationKey)}
            </Typography>
            <Typography color={primitive.$bbqBrown} textAlign="center" variant="copyOne">
              {t('processingSubmittedOrderSubtitle' as TranslationKey)}
            </Typography>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: primitive.$mayoEggWhite,
    flex: 1,
    justifyContent: 'center',
    padding: spacing.$6,
  },
  content: {
    alignItems: 'center',
    gap: spacing.$0,
    maxWidth: '100%',
  },
  textGroup: {
    alignItems: 'center',
    gap: spacing.$0_5,
    marginTop: -spacing.$2,
    maxWidth: 320,
  },
});
